module.exports = __webpack_public_path__ + "img/Sayf_logo.9e1146d.png";